import React from "react";

import { fmtQty } from "@/lib/scan-ui/status";

/** Подсказка вместо «Принять остаток» для кода с упаковки (решение 06.10). */
export const PACKING_REMAINDER_HINT =
  "Короб с упаковки: возьмите нужные штуки и отсканируйте их коды ЧЗ";

/**
 * Перебор по строке в штуках: «Принять остаток — N шт (россыпь)».
 *
 * ⚠️ Для кода С УПАКОВКИ (`source === "packing"`: SSCC короба, код паллеты)
 * кнопки нет. Принятые россыпью N штук уходят в 1С, а короб в портале
 * остаётся «целым» — следующий скан его SSCC засчитал бы штуки, которых в нём
 * уже нет. Часть короба набирают сканом штук ЧЗ: каждая отмечается вынутой,
 * и короб честно становится «вскрытым». Ручную правку количества это не
 * трогает — её владелец оставил.
 */
export function LooseRemainder({
  fromPacking,
  remaining,
  onTake,
}: {
  fromPacking: boolean;
  remaining: number;
  onTake: () => void;
}): React.ReactElement {
  if (fromPacking) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-[12px] text-amber-800">
        {PACKING_REMAINDER_HINT}
      </div>
    );
  }
  return (
    <button
      type="button"
      onClick={onTake}
      className="w-full rounded-xl border-2 border-emerald-400 bg-emerald-50 p-3 text-left"
    >
      <div className="text-[15px] font-bold text-emerald-800">
        Принять остаток — {fmtQty(remaining)} шт (россыпь)
      </div>
      <div className="text-[11px] text-emerald-700">Позиция закроется точно; короб вскрыт, коробов 0</div>
    </button>
  );
}
